import { useCallback, useState } from 'react';

import { getNextPageToken } from 'shared/utils/common';

import type { UseLoadMoreArgs } from './types';

export const useLoadMore = ({
  getChatTopics,
  nextPageUrl,
  setChatTopics,
}: UseLoadMoreArgs) => {
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const loadMore = useCallback(() => {
    const continuationToken = getNextPageToken(
      nextPageUrl,
      'continuationToken',
    );

    setIsLoadingMore(true);

    getChatTopics({ continuationToken }).then(({ data }) => {
      setChatTopics(prevTopics => [...prevTopics, ...(data?.topics || [])]);

      setIsLoadingMore(false);
    });
  }, [getChatTopics, nextPageUrl, setChatTopics]);

  return {
    loadMore,
    isLoadingMore,
  };
};
